module.exports = __webpack_public_path__ + "static/media/punjab-logo.7098d15d.png";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/assets/images/punjab-logo.png
// module id = ../lib/egov-ui-kit/assets/images/punjab-logo.png
// module chunks = 504